import { CodeHighlightAdapterProvider, createShikiAdapter } from "@mantine/code-highlight";
import { ReactNode } from "@tanstack/react-router";

export namespace Shiki {
    async function load() {
        const { createHighlighter } = await import("shiki");
        const shiki = await createHighlighter({
            langs: ["regex", "markdown", "html"],
            themes: [],
        });

        return shiki;
    }

    const adapter = createShikiAdapter(load);

    export const Provider = (props: { children: ReactNode }) => <CodeHighlightAdapterProvider adapter={adapter} {...props} />;
}
